module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loading) ? _c('panel', {
    staticClass: "announcement"
  }, [_c('loader', {
    attrs: {
      "loading": _vm.loading
    }
  })], 1) : _c('panel', {
    attrs: {
      "title": _vm.title,
      "withFooter": false
    }
  }, [(!_vm.product) ? _c('div', {
    attrs: {
      "slot": "header-right"
    },
    slot: "header-right"
  }, [_c('span', [_vm._v("Este anúncio precisa ser migrado")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn--info",
    on: {
      "click": function($event) {
        return _vm.redirectToMigration()
      }
    }
  }, [_vm._v("Migrar")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "l-row"
  }, [_c('panel', {
    staticClass: "blue-panel",
    attrs: {
      "title": "Variações"
    }
  }, [(_vm.product) ? _c('div', {
    staticClass: "l-col-12@md"
  }, [_vm._l((_vm.product.variations), function(announcementVariation) {
    return _c('announcement-match-variation', {
      key: announcementVariation,
      attrs: {
        "announcementVariation": announcementVariation,
        "product": _vm.product,
        "account": _vm.account
      }
    })
  }), _vm._v(" "), _c('span', [_vm._v("Não há mais Matchs disponíveis")])], 2) : _vm._e()])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4c05b3a4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/marketplace/mercadoLivre/AnnouncementMatchCard.vue
// module id = 3139
// module chunks = 0